// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : Added Comment Lines
// MODIFIED DATE: 07-12-2025
import { docodeHexResponse } from '../../_common/common.utils';
import DailyCollectionReportActionTypes from './daily-collection-report.type';

const INITIAL_STATE = {
	// GET DAILY COLLECTION REPORT LIST RESPONSE
	getDailyCollectionReportListResponse: null,
	// GET DAILY COLLECTION REPORT LIST ARRAY
	getDailyCollectionReportListArr: [],
};

const dailyCollectionReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/***************** GET DAILY COLLECTION REPORT LIST START ************* */
		case DailyCollectionReportActionTypes.GET_DAILY_COLLECTION_REPORT_LIST_SUCCESS:
			return {
				...state,
				getDailyCollectionReportListResponse: action.payload,
				getDailyCollectionReportListArr: docodeHexResponse(
					action.payload,
					'DailyCollectionReportKey',
				),
			};

		case DailyCollectionReportActionTypes.GET_DAILY_COLLECTION_REPORT_LIST_FAILURE:
			return {
				...state,
				getDailyCollectionReportListResponse: action.payload,
				getDailyCollectionReportListArr: [],
			};

		case DailyCollectionReportActionTypes.GET_DAILY_COLLECTION_REPORT_LIST_RESPONSE_CHANGED:
			return { ...state, getDailyCollectionReportListResponse: null };
		/***************** GET DAILY COLLECTION REPORT LIST END ************* */
		default:
			return state;
	}
};
export default dailyCollectionReportReducer;
